var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-background"},[_c('div',{staticClass:"container"},[_c('QualiDetail')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }